import Curriculums from './Curriculums';

export default Curriculums;
